module.exports = __webpack_public_path__ + "static/save-the-children-e0509ab92eeeb48eccb9cb25d802925c.png";